import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { ApiService } from '../authentication/guards/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { IOption } from 'ng-select';

@Injectable()
export class FaqService {
  private FaqQuestionAnswer: any;
  constructor(private apiService: ApiService) { }

  getListOfFaQs(id) {
    return this.apiService.get('/faqlist/' + id).map(data => data);
  }

  /**
   * id = null or 0 means get the faqquestions 
   * otherwise get question by its id
   */
  getListOfFaqQuestions(appId) {
    return this.apiService.get('/faqquestionlist/' + appId).map(data => data);
  }

  getFaqQuestions(id) {
    return this.apiService.get('/faqquestion/' + id).map(data => data);
  }

  create(faq, appid) {
    return this.apiService.post('/faq/' + appid, faq).map(data => data);
  }

  delete(id, appid) {
    return this.apiService.delete('/faq/' + appid + '/app/' + id).map(data => data);
  }

  getFaqById(id) {
    return this.apiService.get('/faq/' + id).map(data => data);
  }

  addFaqAnswer(faqWithAnswer, appid) {
    return this.apiService.post('/faqaddanswer/' + appid, faqWithAnswer).map(data => data);
  }

  faqQuestionDelete(id, appid) {
    return this.apiService.delete('/faqquestion/' + appid + '/app/' + id).map(data => data);
  }

  getListOfFaqQuestionsReply(id) {
    return this.apiService.get('/faqquestionreplylist/' + id).map(data => data);
  }

  setFaqQuestionAnswer(question, answer) {
    this.FaqQuestionAnswer = { question: question, answer: answer };
  }
  getFaqQuestionAnswer() {
    return this.FaqQuestionAnswer;
  }

  getListOfFaqRequests(appId) {
    return this.apiService.get('/faqrequestlist/' + appId).map(data => data);
  }

  approve(faq, appid) {
    return this.apiService.post('/faqapproved/' + appid, faq).map(data => data);
  }

  reject(faq, appid) {
    return this.apiService.post('/faqrejected/' + appid, faq).map(data => data);
  }

  getListOfExportFaq(id, LangId) {
    return this.apiService.get('/exportfaqlist/' + id + '/' + LangId).map(data => data);
  }

  getListOfFaqCategories(appId) {
    return this.apiService.get('/getfaqquestioncategorylist/' + appId).map(data => data);
  }

  getFaqQuestionCategoryById(id, appId){
    return this.apiService.get('/getfaqquestioncategorydetailsbyid/' + id + '/' + appId).map(data => data);
  }

  createfaqQuestionCategory(faq, appid){
    return this.apiService.post('/createfaqquestioncategory/' + appid, faq).map(data => data);
  }

  deleteFaqQuestionCategory(id, appid) {
    return this.apiService.delete('/faqQuestionCategory/' + appid + '/app/' + id).map(data => data);
  }

}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/faq-management/faq-management.ts